import React from "react";

const OrderHistoryShimmer = () => {
  return (
    <>
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="w-full bg-white rounded-xl border border-gray-200 p-4 sm:p-5 shadow-sm"
        >
          {/* Top Section */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              {/* Image */}
              <div className="h-12 w-12 rounded-lg shimmer" />

              {/* Title */}
              <div className="h-4 w-32 shimmer rounded-md" />
            </div>

            {/* Status Badge */}
            <div className="h-8 w-20 shimmer rounded-full" />
          </div>

          {/* Date + Price */}
          <div className="flex justify-between mt-4">
            <div className="h-4 w-28 shimmer rounded-md" />
            <div className="h-4 w-16 shimmer rounded-md" />
          </div>

          {/* Bottom Meta */}
          <div className="flex justify-between items-center mt-4">
            <div className="flex gap-3">
              <div className="h-6 w-20 shimmer rounded-full" />
              <div className="h-4 w-10 shimmer rounded-md" />
              <div className="h-4 w-14 shimmer rounded-md" />
            </div>

            <div className="h-6 w-6 shimmer rounded-full" />
          </div>
        </div>
      ))}
    </>
  );
};

export default OrderHistoryShimmer;
